import { IDrillString, IInterval, IInventoryProduct, IProduct } from 'src/Interfaces/TestInterface';
import * as JsCalcs from '../../JavascriptCalculation/JavascriptCalculation';
import { IActiveVolumeArgs, IAdjustedChlorideArgs, IAdjustedSolidsPercentOilArgs, IAdjustedSolidsPercentWaterArgs, IAnnularArgs, IAnnularPressureArgs, IAverageSpecificGravityOilArgs, IAverageSpecificGravityWaterArgs, IBaseOilUsedArgs, IBelowBitVolumeArgs, IBentonitePercentArgs, IBentonitePPBArgs, IBitHydraulicHpArgs, IBitHydraulicHpPerSquareInchArgs, IBottomUpVolumeArgs, IBrineSpecificGravityArgs, ICalcMagnesiumArgs, ICalcPlasticViscosityArgs, ICalcYieldPointArgs, ICapacityBarrelsPerFoot, IChlorideMilsPerLiterArgs, IConvertUnitsArgs, ICriticalVelocityArgs, IDisplacementBarrelsPerFoot, IDrillSolidsBrineEmulsion, IDrillSolidsPercentArgs, IDrillSolidsPPBArgs, IDrillStringSection, IDuplexPumpFlowArgs, IECDArgs, IEffectiveViscosityArgs, IExcessLimeOilArgs, IExcessLimeWaterArgs, IFootageDrilledArgs, IGravityPPBArgs, IHighGravityPercentArgs, IHighGravityPercentWaterArgs, IHighGravityPPGArgs, IHighLowSections, IHoleCapacityArgs, IHydrostaticPressureArgs, IIntervalSection, IJetImpactForceArgs, IJetNozzlePressureDropArgs, IKValueArgs, ILossToCuttingsArgs, ILowGravityPercentArgs, ILowGravityPercentWaterArgs, ILowGravityPPBArgs, IMaximumPipeVelocityArgs, IMudGradientArgs, IMultiplexPumpFlowArgs, INewHoleVolumeArgs, INozzleAreaArgs, INozzleVelocityArgs, INValueArgs, IOilRatioArgs, IOpenPipeVelocityArgs, IPercentPressureDropArgs, IPipeSection, IPluggedPipeVelocityArgs, IRequiredReconciliationArgs, IRetortContentSolidsPercentArgs, IReynoldsNumberArgs, ISaltPercentAdjBrineEmulsion, ISaltPercentBrineEmulsion, ISaltPercentByVolumeArgs, ISaltPercentWWArgs, ISaltWaterPhaseArgs, ISurfaceToBitVolumeArgs, ISurfaceToSurfaceVolumeArgs, ISurgeSwabPressureArgs, ISurgeSwabPressureLossMethod1Args, ITotalAdditionsArgs, ITotalLossesArgs, ITotalVolumeArgs, IVolumeOwedToPlantArgs, IWaterRatioArgs } from './CalcInterfaces';


export class CalcStore {
    private Calcs = JsCalcs;

    public barrelsPerGallon = 0.0238952;

    public annularVelocity(args: IAnnularArgs): number {
        return this.Calcs.annularVelocity(args);
    }

    public calcPlasticViscosity( args: ICalcPlasticViscosityArgs): number {
        return this.Calcs.calcPlasticViscosity(args);
    }

    public calculateBrineSpecificGravity( args: IBrineSpecificGravityArgs) {
        return this.Calcs.brineSpecificGravity(args);
    }
    public calcYieldPoint( args: ICalcYieldPointArgs): number {
        return this.Calcs.calcYieldPoint(args);
    }

    public nozzleArea( args: INozzleAreaArgs ): number {
        return this.Calcs.nozzleArea(args);
    }

    public nozzleVelocity( args: INozzleVelocityArgs ): number {
        return this.Calcs.nozzleVelocity(args);
    }

    public jetImpactForce( args: IJetImpactForceArgs ): number {
        return this.Calcs.jetImpactForce(args);
    }

    public jetNozzlePressureDrop( args: IJetNozzlePressureDropArgs ): number {
        return this.Calcs.jetNozzlePressureDrop(args);
    }

    public bitHydraulicHp( args: IBitHydraulicHpArgs ): number {
        return this.Calcs.bitHydraulicHp(args);
    }

    public bitHydraulicHpPerSquareInch( args: IBitHydraulicHpPerSquareInchArgs ): number {
        return this.Calcs.bitHydraulicHpPerSquareInch(args);
    }

    public percentPressureDrop( args: IPercentPressureDropArgs): number {
        return this.Calcs.percentPressureDrop(args);
    }

    public nValue( args: INValueArgs ): number {
        return this.Calcs.nValueDrillingFormulaCom(args);
    }

    public kValue( args: IKValueArgs ): number {
        return this.Calcs.kValueDrillingFormulaCom(args);
    }

    public pluggedPipeVelocity( args: IPluggedPipeVelocityArgs ): number {
        return this.Calcs.pluggedPipeVelocity(args);
    }

    public openPipeVelocity( args: IOpenPipeVelocityArgs ): number {
        return this.Calcs.openPipeVelocity(args);
    }

    public maximumPipeVelocity( args: IMaximumPipeVelocityArgs ): number {
        return this.Calcs.maximumPipeVelocity(args);
    }

    public surgeSwabPressureLossMethod1( args: ISurgeSwabPressureLossMethod1Args): number {
        const tempArgs: any = args;
        tempArgs.openPipeVelocityFunction = this.Calcs.openPipeVelocity;
        tempArgs.pluggedPipeVelocityFunction = this.Calcs.pluggedPipeVelocity;
        tempArgs.maximumPipeVelocityFunction = this.Calcs.maximumPipeVelocity;
        tempArgs.pressureLossFunction = this.Calcs.pressureLossLaminar;
        tempArgs.kValueFunction = this.Calcs.kValue;
        tempArgs.nValueFunction = this.Calcs.nValue;
        return this.Calcs.surgeSwabPressureLossMethod1(tempArgs);
    }

    public criticalVelocity( args: ICriticalVelocityArgs ): number {
        return this.Calcs.criticalVelocityDrillingFormulas(args);
    }

    public swabPressure( args: ISurgeSwabPressureArgs ): number {
        return this.Calcs.swabPressure(args);
    }

    public surgePressure( args: ISurgeSwabPressureArgs ): number {
        return this.Calcs.surgePressure(args);
    }

    public ECD( args: IECDArgs ): number {
        return this.Calcs.ECD(args);
    }


    public calcPipeSections(drillStringSections: IDrillStringSection[], intervalSections: IIntervalSection[]): IPipeSection[] | undefined {
        return this.Calcs.getSections({drillStringSections, intervalSections}) as IPipeSection[];
    }

    public hydrostaticPressure(args: IHydrostaticPressureArgs) {
        return this.Calcs.hydrostaticPressure(args);
    }

    public duplexPumpFlowRateGallonsPerStroke(args: IDuplexPumpFlowArgs) {
        return this.Calcs.duplexPumpFlowRateGallonPerStroke(args);
    }

    public multiplexPumpFlowRateGallonsPerStroke(args: IMultiplexPumpFlowArgs) {
        return this.Calcs.multiplexPumpFlowRateGallonPerStroke(args);
    }

    public convertUnitFromPerStrokeToPerMinute(strokesPerMinute: number, unitPerStroke: number) {
        return strokesPerMinute * unitPerStroke;
    }

    public capacityInBarrelsPerFoot(args:ICapacityBarrelsPerFoot) {
        const tempArgs = {
            innerDiameter: 0,
            length: args.length,
            outerDiameter: args.innerDiameter,
        };
        return this.Calcs.cylinderVolumeBarrels(tempArgs) / args.length;
    }

    public displacementInBarrelsPerFoot(args: IDisplacementBarrelsPerFoot) {
        return this.Calcs.cylinderVolumeBarrels(args) / args.length;
    }

    public surfaceToBitVolumeBarrels(args: ISurfaceToBitVolumeArgs) {
        const tempArgs: any = args;
        tempArgs.cylinderVolumeFunction = this.Calcs.cylinderVolumeBarrels;
        return this.Calcs.surfaceToBitVolume(tempArgs);
    }

    public bottomUpVolumeBarrels(args: IBottomUpVolumeArgs) {
        const tempArgs: any = args;
        tempArgs.cylinderVolumeFunction = this.Calcs.cylinderVolumeBarrels;
        return this.Calcs.bottomUpVolume(args);
    }

    public surfaceToSurfaceVolumeBarrels(args: ISurfaceToSurfaceVolumeArgs) {
        return this.Calcs.surfaceToSurfaceVolume(args);
    }

    public belowBitVolumeBarrels(args: IBelowBitVolumeArgs) {
        const tempArgs: any = args;
        tempArgs.cylinderVolumeFunction = this.Calcs.cylinderVolumeBarrels;
        return this.Calcs.belowBitVolume(tempArgs);
    }

    public activeVolumeBarrels(args: IActiveVolumeArgs) {
        return this.Calcs.activeVolume(args);
    }

    public holeCapacityBarrels(args: IHoleCapacityArgs) {
        return this.Calcs.holeCapacity(args);
    }

    public convertUnits(args: IConvertUnitsArgs) {
        return this.Calcs.convertUnits(args);
    }

    public excessLimeOil(args: IExcessLimeOilArgs) {
        return this.Calcs.excessLimeOil(args);
    }

    public excessLimeWater(args: IExcessLimeWaterArgs) {
        return this.Calcs.excessLimeWater(args);
    }

    public calcMagnesium(args: ICalcMagnesiumArgs) {
        return this.Calcs.calcMagnesium(args);
    }

    public mudGradient(args: IMudGradientArgs) {
        return this.Calcs.mudGradient(args);
    }

    public adjustDrillStringAssembly(drillStringAssembly: IDrillString[], bitDepth: number) {
        let depthRemaining = Number(bitDepth);
        if (depthRemaining === 0) {
            return;
        }
        for ( let i = 0; i < drillStringAssembly.length; ++i ) {
            if (depthRemaining > Number(drillStringAssembly[i].length)) {
                depthRemaining -= Number(drillStringAssembly[i].length);
            } else {
                drillStringAssembly[i].length = depthRemaining;
                depthRemaining = 0;
                drillStringAssembly.splice(i + 1, drillStringAssembly.length - (i +1));
                break;
            }
        }

        if (depthRemaining > 0) {
            drillStringAssembly[drillStringAssembly.length - 1].length = depthRemaining 
                + Number(drillStringAssembly[drillStringAssembly.length - 1].length);
        }
    }

    public convertDrillStringAssembly(drillStringAssembly: IDrillString[], bitDepth: number):IDrillStringSection[] {
        
        if (bitDepth === 0) {
            return [{
                innerPipeDiameter: 0,
                length: 0,
                outerPipeDiameter: 0,
            }];
        }
        
        const retArr: IDrillStringSection[] = [];
        const currentDrillString = drillStringAssembly.slice().reverse();
        let drillStringLength: number = 0;
        for (const drillString of currentDrillString) {
            const newDrillStringSection: IDrillStringSection = {
                innerPipeDiameter: Number(drillString.innerDiameter),
                length: Number(drillString.length),
                outerPipeDiameter: Number(drillString.outerDiameter),
            };
            if( newDrillStringSection.length !== 0) {
                retArr.push(newDrillStringSection);
                drillStringLength += newDrillStringSection.length;
            }
        }

        if ( drillStringLength > bitDepth ) {
            let depthRemaining = bitDepth;
            for (let i = retArr.length -1; i >= 0; i--) {
                if ( depthRemaining > retArr[i].length ) {
                    depthRemaining -= retArr[i].length;
                } else {
                    retArr[i].length = depthRemaining;
                    retArr.splice(0, i);
                    break;
                }
            }
        }
        return retArr;
    }

    // public convertIntervalsOld(myIntervals: IInterval[], estHoleDiameter: number):IIntervalSection[] {
    //     const retArr: IIntervalSection[] = [];
    //     const activeIntervals = myIntervals.slice().reverse();
    //     let currentDepth = 0;
    //     for( let i = 0; i < activeIntervals.length; ++i) {

    //         if (activeIntervals[ i + 1 ]) {
    //             if (Number(activeIntervals[ i + 1 ].casingID) !== 0 && Number(activeIntervals[ i + 1].casingTop) === 0) {
    //                 continue;
    //             }
    //         }
            
    //         const currentTop = activeIntervals[i].casingID ? activeIntervals[i].casingTop : Number(activeIntervals[i].topFt);
    //         let currentLength = Number(activeIntervals[i].bottomFt) - currentTop;
    //         currentDepth += currentLength;
    //         if (activeIntervals[ i + 1 ] 
    //             && Number(activeIntervals[ i + 1].casingID) !== 0
    //             && Number(activeIntervals[ i + 1].casingTop) < currentDepth ) {
    //             const depthDiff = (Number(activeIntervals[i].bottomFt) - Number(activeIntervals[i+1].casingTop));
    //             currentLength -= depthDiff;
    //             currentDepth -= depthDiff;
    //         }
    //         const holeDiameter = activeIntervals[i].casingID ? activeIntervals[i].casingID : estHoleDiameter;
    //         const newInterval: IIntervalSection = {
    //             holeDiameter,
    //             length: currentLength,
    //         };
            
    //         if ( newInterval.length > 0 ) {
    //             retArr.push(newInterval);
    //         }
    //     }
    //     return retArr;
    // }

    // public convertIntervalsOldv2(myIntervals: IInterval[], estHoleDiameter: number):IIntervalSection[] {
    //     const retArr: IIntervalSection[] = [];
    //     const activeIntervals = myIntervals.slice();
    //     let previousIntervalTop = null;
    //     for(const myInterval of activeIntervals) {
            
    //         let intervalBottom = myInterval.casingBottom ? myInterval.casingBottom : 
    //             (myInterval.plugBackDepth ? myInterval.plugBackDepth : myInterval.bottomFt);
    //         if (previousIntervalTop && previousIntervalTop < intervalBottom) {
    //             intervalBottom = previousIntervalTop;
    //         }
    //         const intervalTop = myInterval.casingID ? myInterval.casingTop : myInterval.topFt;
    //         const intervalSection: IIntervalSection = {
    //             hasCasing: Number(myInterval.casingID) > 0,
    //             holeDiameter: 
    //                 myInterval.casingID ? myInterval.casingID : 
    //                 (myInterval.estHoleSize ? myInterval.estHoleSize : estHoleDiameter),
    //             length: intervalBottom - intervalTop,
    //         };

    //         if (intervalSection.length <= 0) {
    //             continue;
    //         }
    //         previousIntervalTop = intervalTop;
    //         retArr.unshift(intervalSection);
    //         if (Number(intervalTop) === 0) {
    //             break;
    //         }

    //     }
    //     return retArr;
    // }

    public convertIntervals(myInterval: IInterval[], estHoleDiameter: number) {
        const retArr: IIntervalSection[] = [];
        if (myInterval.length === 0) {
            return retArr;
        }
        const currInt = myInterval[0];
        let currentDepth = currInt.plugBackDepth ? currInt.plugBackDepth : currInt.bottomFt;
        if (Array.isArray(currInt.casings) && currInt.casings.length > 0) {
            const currCasing = currInt.casings[0];
            if (currCasing.casingBottom < currentDepth) {
                const intervalSection = {
                    hasCasing: false,
                    holeDiameter: currInt.estHoleSize ? currInt.estHoleSize : estHoleDiameter,
                    length: currentDepth - currCasing.casingBottom,
                };
                retArr.unshift(intervalSection);
                currentDepth = currCasing.casingBottom;
            }
        }
        for(const currInterval of myInterval) {
            if (Array.isArray(currInterval.casings) && currInterval.casings.length > 0) {
                for (const currCas of currInterval.casings) {
                    if (currentDepth > currCas.casingTop) {
                        const intervalSection = {
                            hasCasing: true,
                            holeDiameter: currCas.casingID,
                            length: currentDepth - currCas.casingTop,
                        };
                        retArr.unshift(intervalSection);
                        currentDepth = currCas.casingTop;
                    }
                }
            }
            if (currentDepth > currInterval.topFt) {
                const intervalSection = {
                    hasCasing: false,
                    holeDiameter: currInterval.estHoleSize ? currInterval.estHoleSize : estHoleDiameter,
                    length: currentDepth - currInterval.topFt,
                };
                retArr.unshift(intervalSection);
                currentDepth = currInterval.topFt;
            }
        }
        return retArr;
    }

    public calculateAnnularVelocities(highLowSections: IHighLowSections | undefined, circRate: number) {
        if (!highLowSections) {
            return undefined;
        }
        return {
            highestFlowAnnularVelocity: this.annularVelocity({
                circRate,
                holeDiameter: highLowSections.highestFlowSection.holeDiameter,
                pipeDiameter: highLowSections.highestFlowSection.outerPipeDiameter,
            }),
            lowestFlowAnnularVelocity: this.annularVelocity({
                circRate,
                holeDiameter: highLowSections.lowestFlowSection.holeDiameter,
                pipeDiameter: highLowSections.lowestFlowSection.outerPipeDiameter,
            }),
        };
    }

    
// the lowest flow area calc must not include pipe sections with casing per Dale 7/24/2019
    public getHighestLowestAreaPipeSections(pipeSections: IPipeSection[] | undefined): IHighLowSections | undefined {
        if (!pipeSections) { return undefined; }
        if (pipeSections.length === 0 ) { return undefined; }

        let lowestFlowSection = pipeSections[0];
        let lowestFlowArea = 0;
        let highestFlowSection = lowestFlowSection;
        let highestFlowArea = Number.POSITIVE_INFINITY;
        for (let i = 1; i < pipeSections.length; i++) {
            const currFlowSection = pipeSections[i];
            const currentFlowArea = Math.pow(currFlowSection.holeDiameter, 2) - Math.pow(currFlowSection.outerPipeDiameter, 2);
            if (currentFlowArea < highestFlowArea) {
                highestFlowSection = currFlowSection;
                highestFlowArea = currentFlowArea;
            } 
            if (currentFlowArea > lowestFlowArea && !currFlowSection.hasCasing) {
                lowestFlowSection = currFlowSection;
                lowestFlowArea = currentFlowArea;
            }
        }
        return {
            highestFlowSection,
            lowestFlowSection
        };
    }

    public calculateEffectiveViscosity(args: IEffectiveViscosityArgs) {
        return this.Calcs.effectiveViscosity(args);
    }

    public calculateReynoldsNumber(args: IReynoldsNumberArgs) {
        return this.Calcs.reynoldsNumber(args);
    }

    public calculateRetortContentSolidsPercent(args: IRetortContentSolidsPercentArgs) {
        return this.Calcs.retortContentSolidsPercent(args);
    }

    public calculateOilRatio(args: IOilRatioArgs) {
        return this.Calcs.oilRatio(args);
    }

    public calculateWaterRatio(args: IWaterRatioArgs) {
        return this.Calcs.waterRatio(args);
    }

    public calculateAdjustedSolidsPercentWater(args: IAdjustedSolidsPercentWaterArgs) {
        return this.Calcs.adjustedSolidsPercentWater(args);
    }
    public calculateAdjustedSolidsPercentOil(args: IAdjustedSolidsPercentOilArgs) {
        const tempArgs:any = args;
        tempArgs.sodiumChloridePresentFunction = this.Calcs.sodiumChloridePresent;
        return this.Calcs.adjustedSolidsPercentOil(tempArgs);
    }

    public calculateLimeContent(args: IExcessLimeOilArgs) {
        return this.Calcs.excessLimeOil(args);
    }

    public calculateAverageSpecificGravityOil(args: IAverageSpecificGravityOilArgs) {
        const tempArgs:any = args;
        tempArgs.sodiumChloridePresentFunction = this.Calcs.sodiumChloridePresent;
        return this.Calcs.averageSpecificGravityOil(tempArgs);
    }

    public calculateSaltPercentWW(args: ISaltPercentWWArgs) {
        const tempArgs:any = args;
        tempArgs.getSaltTypeCoefficientFunction = this.Calcs.getSaltTypeCoefficient;
        return this.Calcs.saltPercentWW(tempArgs);
    }
    public calculateSaltPercentByVolume(args: ISaltPercentByVolumeArgs) {
        return this.Calcs.saltPercentByVolume(args);
    }

    public calculateSaltWaterPhase(args: ISaltWaterPhaseArgs) {
        const tempArgs: any = args;
        tempArgs.sodiumChloridePresentFunction = this.Calcs.sodiumChloridePresent;
        return this.Calcs.saltWaterPhase(tempArgs);
    }
    public calculateLowGravityPercent(args: ILowGravityPercentArgs) {
        const tempArgs:any = args;
        tempArgs.sodiumChloridePresentFunction = this.Calcs.sodiumChloridePresent;
        return this.Calcs.lowGravityPercent(tempArgs);
    }

    public calculateLowGravityPPB(args: ILowGravityPPBArgs) {
        const tempArgs:any = args;
        tempArgs.sodiumChloridePresentFunction = this.Calcs.sodiumChloridePresent;
        return this.Calcs.lowGravityPPB(tempArgs);
    }

    public calculateHighGravityPercent(args: IHighGravityPercentArgs) {
        const tempArgs:any = args;
        tempArgs.sodiumChloridePresentFunction = this.Calcs.sodiumChloridePresent;
        return this.Calcs.highGravityPercent(tempArgs);
    }

    public calculateHighGravityPPG(args: IHighGravityPPGArgs) {
        const tempArgs:any = args;
        tempArgs.sodiumChloridePresentFunction = this.Calcs.sodiumChloridePresent;
        return this.Calcs.highGravityPPG(tempArgs);
    }

    public calculateChlorideMilsPerLiter(args: IChlorideMilsPerLiterArgs) {
        const tempArgs:any = args;
        tempArgs.sodiumChloridePresentFunction = this.Calcs.sodiumChloridePresent;
        return this.Calcs.chlorideMilsPerLiter(tempArgs);
    }

    public calculateCaCL2mgLWPS(args: IChlorideMilsPerLiterArgs) {
        const tempArgs:any = args;
        tempArgs.sodiumChloridePresentFunction = this.Calcs.sodiumChloridePresent;
        return this.Calcs.caCL2mgLWPS(tempArgs);
    }

    public calculateAverageSpecificGravityWater(args: IAverageSpecificGravityWaterArgs) {
        const tempArgs: any = args;
        tempArgs.getSaltTypeCoefficientFunction = this.Calcs.getSaltTypeCoefficient;
        return this.Calcs.averageSpecificGravityWater(args);
    }

    public calculateLowGravityPercentWater(args: ILowGravityPercentWaterArgs) {
        const tempArgs: any = args;
        tempArgs.getSaltTypeCoefficientFunction = this.Calcs.getSaltTypeCoefficient;
        return this.Calcs.lowGravityPercentWater(tempArgs);
    }

    public calculateHighGravityPercentWater(args: IHighGravityPercentWaterArgs) {
        return this.Calcs.highGravityPercentWater(args);
    }

    public calculateLowGravityPPBWater(args: IGravityPPBArgs) {
        return this.Calcs.gravityPPB(args);
    }

    public calculateHighGravityPPBWater(args: IGravityPPBArgs) {
        return this.Calcs.gravityPPB(args);
    }

    public calculateBentonitePercent(args: IBentonitePercentArgs) {
        return this.Calcs.bentonitePercent(args);
    }

    public calculateBentonitePPB(args: IBentonitePPBArgs) {
        return this.Calcs.bentonitePPB(args);
    }

    public calculateDrillSolidsPercent(args: IDrillSolidsPercentArgs) {
        return this.Calcs.drillSolidsPercent(args);
    }

    public calculateDrillSolidsPPB(args: IDrillSolidsPPBArgs) {
        return this.Calcs.drillSolidsPPB(args);
    }

    public calculateSaltPercentBrine(args: ISaltPercentBrineEmulsion) {
        return this.Calcs.saltPercentBrineEmulsion(args);
    }

    public calculateSaltPercentAdjBrine(args: ISaltPercentAdjBrineEmulsion) {
        return this.Calcs.saltPercentAdjBrineEmulsion(args);
    }

    public calculateDrillSolidsBrine(args: IDrillSolidsBrineEmulsion) {
        return this.Calcs.drillSolidsBrineEmulsion(args);
    }

    public calculateAdjustedChloride(args: IAdjustedChlorideArgs) {
        return this.Calcs.adjustedChloride(args);
    }

    public calculateNewHoleVolume(args: INewHoleVolumeArgs) {
        return (args.estimatedHoleSize * args.estimatedHoleSize / 1029.41) * (args.currentDepthMD - args.previousDepthMD);
    }

    public calculateFootageDrilled(args: IFootageDrilledArgs) {
        return args.currentDepthMD - args.previousDepthMD;
    }

    public calculateVolumeOwedToPlant(args: IVolumeOwedToPlantArgs) {
        return args.previousVolumeOwed + args.volumeReceived - args.volumeReturned;
    }

    public calculateCumBaseOilUsed(currentBaseOil: number, prevBaseOil: number) {
        return prevBaseOil + currentBaseOil;
    }

    public calculateBaseOilUsed(args: IBaseOilUsedArgs) {
        return args.startingBaseOil + args.baseOilReceived - args.endingBaseOil;
    }

    public calculateBaseOilUsedBarrels( baseOilUsedGallons: number ) {
        return this.convertUnits({valueToConvert: baseOilUsedGallons, conversionFactor: 0.0238095});  // From google
    }

    public calculateTotalAdditions(args :ITotalAdditionsArgs) {
        return args.baseOilUsedBarrels + args.water + args.chemicalAdditions + args.slurry + args.otherAdditions + args.otherReceived + args.washout + args.xferFromStorage + args.plantVolRecvd;
    }

    public calculateLossesToCuttings(args :ILossToCuttingsArgs) {
        return args.lossCuttingRatio * args.newHoleVolume;
    }
    public calculateTotalLosses(args: ITotalLossesArgs) {
        return args.lossCuttings + args.lossFormation + args.lossSurface + args.mudInHole + args.otherLosses + args.solidsControl + args.plantVolReturned + args.otherTransfered;
    }

    public calculateTotalVolume(args: ITotalVolumeArgs) {
        return args.externalStorage + args.pvt + args.totalHoleVolume;
    }

    public calculateRequiredReconciliation(args: IRequiredReconciliationArgs) {
        return args.totalVolume - (args.previousTotalHoleVolume + args.totalAdditions - args.totalLosses);
    }

    public calculateAnnularPressureLoss(args: IAnnularPressureArgs) {
        const tempArgs:any = args;
        tempArgs.annularVelocityFunction = this.Calcs.annularVelocity;
        tempArgs.annularPressureLossSectionFunction = this.Calcs.annularPressureLossSection;
        return this.Calcs.annularPressureLoss(args);
    }

    /**
     * 
     * Caluculate Product Volume in barrels per item
     * 350.5 lb/bbl density of water
     * Weight of Item / ( Specific Gravity * 350.5 ) = Volume in barrels
     */
    public calculateProductVolume(product: IProduct) {
        let retVal = 0;
        switch (product.unit) {
            case 'gal.':
                retVal = Number(product.size) / 42;
                break;
            case 'bbl.':
                retVal = Number(product.size);
                break;
            default:
                retVal = Number(product.weight) / ( Number(product.specificGravity) * 350.5 );
                break;
        }
        return !Number.isFinite(retVal) ? 0 : retVal;
    }

    public calculateChemicalAddition(productList: IInventoryProduct[]) {
        return productList.reduce((total, currentValue) => {
            return total + this.calculateProductVolume(currentValue.product) * currentValue.amountUsed;
        }, 0);
    }
}

export default new CalcStore();


// WEBPACK FOOTER //
// ./src/Stores/Calc/CalcStore.ts